import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ImageLogo from '../assets/images/Logoimage.png';
import {Hidden, Menu, MenuItem} from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import Breadcrumbs from './Breadcrumbs';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";

const useStyles = makeStyles((theme) => ({
  root: { flexGrow: 1, },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  menu:{ "& .MuiPaper-root": {backgroundColor: "fff",
  overflowX:'hidden !important',overflowY:'auto!important'}},
  appbar:{
     color:'#515974',boxShadow:'none'
  },
  toolbar:{
      justifyContent: 'space-between', minHeight:'64px'
  },
  navLeft:{
    display:'flex', alignItems:'center', fontSize:'22px', color:'black'
  },
  navlogo:{
    paddingTop:'10px', paddingRight:'30px'
  },
  navright:{ display:'flex', alignItems:'center'},
  navlinkstyles:{ textDecoration:'none', color:'black'},
  home:{textDecoration:'none', marginRight:'10px', color:'#06303f', fontSize:'17px'}
}));

function Navbar(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = ()=>{
    setAnchorEl(null);
    props.currentUser.changeUser();
    props.history.push('/guest/Login');
  };
  return (
    <div className={classes.root}>
      <AppBar position="static" style={{backgroundColor:"white"}} className={classes.appbar}>
        <Toolbar variant="dense" className={classes.toolbar}>
          <Hidden smDown>
            <div className={classes.navLeft}>
              <NavLink to={'/Home'} className={classes.navlogo}>
                <img src={ImageLogo} alt="logo" width="124px" />
              </NavLink>
              <p>Content Management</p>
            </div>
          </Hidden>
          <div className={classes.navright}>
            <NavLink to={'/Home'} className={classes.home}>
              <p>Home</p>
            </NavLink>
            <p className={classes.home}>{props.currentUser.userDetails.email}</p>
            <IconButton edge="end" className={classes.menuButton} color="inherit" aria-label="menu" onClick={handleClick}>
              <MenuIcon aria-controls="simple-menu" aria-haspopup="true"/>
            </IconButton>
          </div>
        </Toolbar>
        <Breadcrumbs />
      </AppBar>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose} className={classes.menu} >
        <NavLink to={`${props.match.url}/Article`} activeStyle={{ fontWeight: "bold", color: "black", textDecoration:'none' }} className={classes.navlinkstyles}>
          <MenuItem onClick={handleClose}>Article </MenuItem>
        </NavLink>
        <NavLink to={`${props.match.url}/Trivia`} activeStyle={{ fontWeight: "700", color: "black", textDecoration:'none' }} className={classes.navlinkstyles}>
          <MenuItem onClick={handleClose}>Trivia</MenuItem>
        </NavLink>
        <NavLink to={`${props.match.url}/Meditation`} activeStyle={{ fontWeight: "bold", color: "black", textDecoration:'none' }} className={classes.navlinkstyles}>
          <MenuItem onClick={handleClose}>Meditation</MenuItem>
        </NavLink>
        <NavLink to={`${props.match.url}/Curriculum`} activeStyle={{ fontWeight: "bold", color: "black", textDecoration:'none' }} className={classes.navlinkstyles}>
          <MenuItem onClick={handleClose}>Curriculum</MenuItem>
        </NavLink>
        <NavLink to={`${props.match.url}/AFB`} activeStyle={{ fontWeight: "bold", color: "black", textDecoration:'none' }} className={classes.navlinkstyles}>
          <MenuItem onClick={handleClose}>AFB </MenuItem>
        </NavLink>
        <NavLink to="/" activeStyle={{ fontWeight: "bold", color: "black", textDecoration:'none' }} className={classes.navlinkstyles}>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </NavLink>
      </Menu>

    </div>
  );
}
export default AuthenticatedPage()(Navbar);